import { Filter, RotateCcw } from "lucide-react";

import { Card } from "../../../shared/card/card.tsx";
import { Button, Select, type SelectOption } from "../../../ui/index.ts";
import styles from "./utilization-report-components.module.css";

export function UtilizationReportFilters({
  employeeId,
  departmentId,
  employeeOptions,
  departmentOptions,
  loading,
  error,
  onEmployeeChange,
  onDepartmentChange,
  onApply,
  onClear,
}: {
  employeeId: string;
  departmentId: string;
  employeeOptions: SelectOption[];
  departmentOptions: SelectOption[];
  loading: boolean;
  error: string | null;
  onEmployeeChange: (value: string) => void;
  onDepartmentChange: (value: string) => void;
  onApply: () => void;
  onClear: () => void;
}) {
  return (
    <Card>
      <div className={styles.filterRow}>
        <div className={styles.field}>
          <Select label="Employee Name" placeholder={loading ? "Loading..." : "Select Employee Name"} value={employeeId} onChange={onEmployeeChange} options={employeeOptions} searchable isClearable disabled={loading} />
        </div>
        <div className={styles.field}>
          <Select label="Department" placeholder={loading ? "Loading..." : "Select Department"} value={departmentId} onChange={onDepartmentChange} options={departmentOptions} searchable isClearable disabled={loading} />
        </div>
        <div className={styles.actions}>
          <Button type="button" variant="accent" startIcon={<Filter size={16} aria-hidden />} onClick={onApply} disabled={loading}>Filter</Button>
          <Button type="button" variant="light-grey" startIcon={<RotateCcw size={16} aria-hidden />} onClick={onClear} disabled={loading}>Clear Filter</Button>
        </div>
      </div>
      {error ? <p className={styles.error}>{error}</p> : null}
    </Card>
  );
}
